package music.jammers.client.shared.event.track.domain.usecase

import music.jammers.client.shared.event.track.domain.repository.EventTrackRepository
import music.jammers.shared.event.track.domain.model.AddEventTrack
import music.jammers.shared.event.track.domain.model.EventTrack

class AddEventTrackUseCase(
    private val eventTrackRepository: EventTrackRepository,
) {

    suspend operator fun invoke(eventId: Long, addEventTrack: AddEventTrack): EventTrack =
        eventTrackRepository.create(eventId, addEventTrack)
}